import React, { Component } from 'react';
import TemperatureRangesView from './TemperatureRangesView';
import { connect } from 'react-redux';
import * as tripActions from '../../../actions/tripActions';

class TemperatureRangeContainer extends Component {
  changeStep = (step, values) => {
    const { changeCurrentStep, saveTripData } = this.props;
    changeCurrentStep(step);
    saveTripData(values);
  };

  render() {
    return (
      <TemperatureRangesView {...this.props} changeStep={this.changeStep} state={this.state} />
    );
  }
}

function mapStateToProps(state) {
  return {
    temperature_ranges: state.tripReducer.tripForm.temperature_ranges,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeCurrentStep: step => dispatch(tripActions.changeCurrentStep(step)),
    saveTripData: data => dispatch(tripActions.saveTripData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TemperatureRangeContainer);
